import React from 'react';
import { Modal, Box } from '@mui/material';
import { KTSVG } from '_metronic/helpers';

const TnCModal = ({ tncModalIsOpen, handleTnCModalClose }) => {
	const style = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '80vw',
		bgcolor: 'background.paper',
		boxShadow: 24,
		p: 4,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		// justifyContent: 'center',     // Causing scroll issue
		maxHeight: '80vh',
		overflow: 'auto'
	};
	return <>
		<Modal
			open={tncModalIsOpen}
			onClose={handleTnCModalClose}
		>
			<Box sx={style}>
				{/* Modal close button */}
				<button
					type='button'
					className='btn btn-sm btn-icon explore-btn-dismiss me-n5'
					// id='kt_explore_close'
					onClick={() => { handleTnCModalClose(false) }}
					style={{ position: 'absolute', top: 20, right: 30 }}
				>
					<KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
				</button>

				<h1 style={{ marginBottom: 20 }}>General Terms of Use</h1>

				{/* Terms Of Use */}
				<div style={{ textAlign: 'justify' }}>
					<p>
						<b style={{ color: 'black' }}>NB</b>
						.​ These are the <b style={{ color: 'black' }}>  ​general ​</b>
						site terms, relevant when browsing APICon.io. For terms relating to creating and managing an account, please see the SaaS terms, at
						<a href="https://www.supista.com/legal/saasterms" target="_blank"> here.</a>
					</p>
					<p><i>Effective starting May 07, 2020</i></p>
					<p>
						This website (
						<b style={{ color: 'black' }}>​Site​</b>
						) is operated by APICON SOLUTIONS PRIVATE LIMITED (
						<b style={{ color: 'black' }}>we​, ​our​ or us</b>
						).  It is available at:
						<a href="/" target="_blank" rel="noreferrer"> Link</a> 
						&nbsp;and may be available through other addresses or channels.
					</p>
					<p>
						<b style={{ color: 'black' }}>Consent </b>
						:​ By accessing and/or using our Site, you agree to these terms of use and our Privacy Policy (
						<a href="https://www.supista.com/legal/privacypolicy" target="_blank">Link</a>
						) (
						<b style={{ color: 'black' }}>​Terms​</b>
						). Please read these Terms carefully and immediately cease using our Site if you do not agree to them.
					</p>
					<p>
						<b style={{ color: 'black' }}>Variations </b>
						:​ We may, at any time and at our discretion, vary these Terms by publishing the varied terms on our Site. We recommend you check our Site regularly to ensure you are aware of our current terms. Materials and information on this Site (
						<b style={{ color: 'black' }}>​Content​</b>
						) are subject to change without notice. We do not undertake to keep our Siteup-to-date and we are not liable if any Content is in accurate or out-of-date.
					</p>
					<p>
						<b style={{ color: 'black' }}> Licence to use our Site​</b>
						: We grant you a non-exclusive, royalty-free, revocable, worldwide, non-transferable licence to use our Site in accordance with these Terms. All other uses are prohibited without our prior written consent.
					</p>
					<p>
						<b style={{ color: 'black' }}> Prohibited conduct</b>
						: You must not do or attempt to do anything: that is unlawful; prohibited by any laws applicable to our Site; which we would consider inappropriate; or which might bring us or our Site into disrepute, including (without limitation):
					</p>
					<ol>
						<li>anything that would constitute a breach of an individual’s privacy (including uploading private or personal information without an individual's consent) or any other legal rights;</li>
						<li>using our Site to defame, harass, threaten, menace or offend any person;</li>
						<li>interfering with any user using our Site;</li>
						<li>tampering with or modifying our Site, knowingly transmitting viruses or other disabling features, or damaging or interfering with our Site, including (without limitation) using trojan horses, viruses or piracy or programm ingroutines that may damage or interfere with our Site;</li>
						<li>using our Site to send unsolicited email messages; or</li>
						<li>facilitating or assisting a third party to do any of the above acts.</li>
					</ol>
					<p>
						<b style={{ color: 'black' }}> Exclusion of competitors</b>
						: You are prohibited from using our Site, including the Content, in any way that competes with our business.
					</p>
					<p>
						<b style={{ color: 'black' }}> Information​</b>
						: The Content is not comprehensive and is for general information purposes only.  It does not take into account your specific needs, objectives or circumstances, and it is not advice.  While we use reasonable attempts to ensure the accuracy and completeness of the Content, we make no representation or warranty in relation to it, to the maximum extent permitted by law.
					</p>
					<p>
						<b style={{ color: 'black' }}> Intellectual Property rights</b>
						:​ Unless otherwise indicated, we own or licence all rights, title and interest (including intellectual property rights) in our Site and all of the Content. Your use of our Site and your use of and access to any Content does not grant or transfer to you any rights, title or interest in relation to our Site or the Content. You must not:
					</p>
					<ol>
						<li>copy or use, in whole or in part, any Content;</li>
						<li>reproduce, retransmit, distribute, disseminate, sell, publish, broadcast or circulate any Content to any third party; or</li>
						<li>breach any intellectual property rights connected with our Site or the Content, including (without limitation) altering or modifying any of the Content, causing any of the Content to be framed or embedded in another website or platform, or creating derivative works from the Content.</li>
					</ol>
					<p>
						<b style={{ color: 'black' }}> User Content</b>
						:​You may be permitted to post, upload, publish, submit or transmit relevant information and content (User Content) on our Site. We claim no ownership of the intellectual property rights in User Content you provide to the Site. Your profile and materials uploaded remain yours. However, by setting your pages to be shared publicly or making available any User Content on or through our Site, you agree to allow others to view and share your User Content and you grant to us a worldwide, irrevocable, perpetual, non-exclusive, transferable, royalty-free licence to use the User Content​, with the right to use, view, copy, adapt, modify, communicate, publicly display, publicly perform, transmit, stream, broadcast, access such User Content on, through or by means of our Site
					</p>
					<p>You agree that you are solely responsible for all User Content that you make available on or through our Site.  You represent and warrant that:</p>
					<ol>
						<li>
							you are either the sole and exclusive owner of all User Content or you have all rights, licences, consents and releases that are necessary to
							grant to us the rights in such User Content (as contemplated by these Terms); and
						</li>
						<li>neither the User Content nor the posting, uploading, publication, submission or transmission of the User Content or our use of the User Content on, through or by means of our Site will infringe, misappropriate or violate a third party’s intellectual property rights, or rights of publicity or privacy, or result in the violation of any applicable law or regulation.</li>
					</ol>
					<p>We do not endorse or approve, and are not responsible for, any User Content. We may, at any time (at our sole discretion), remove any User Content.</p>
					<p>
						<b style={{ color: 'black' }}> Third party sites</b>
						: Our Site may contain links to websites operated by third parties. Unless expressly stated otherwise, we do not control, endorse or approve, and are not responsible for, the content on those websites.  You should make your own investigations with respect to the suitability of those websites.
					</p>
					<p>
						<b style={{ color: 'black' }}> Discontinuance​</b>
						: We may, at any time and without notice to you, discontinue our Site, in whole or in part.  We may also exclude any person from using our Site, at any time and at our sole discretion. We are not responsible for any Liability you may suffer arising from or in connection with any such discontinuance or exclusion.
					</p>
					<p>
						<b style={{ color: 'black' }}> Warranties and disclaimers</b>
						: To the maximum extent permitted by law, we make no representations or warranties about our Site or the Content, including (without limitation) that:
					</p>
					<ol>
						<li>they are complete, accurate, reliable, up-to-date and suitable for any particular purpose;</li>
						<li>access will be uninterrupted, error-free or free from viruses; or</li>
						<li>our Site will be secure.</li>
					</ol>
					<p>You read, use and act on our Site and the Content at your own risk.</p>
					<p>
						<b style={{ color: 'black' }}> Limitation of liability​</b>
						: To the maximum extent permitted by law, we are not responsible for any loss, damage or expense, howsoever arising, whether direct or indirect and/or whether present, unascertained, future or contingent (
						<b style={{ color: 'black' }}> ​Liability​</b>
						) suffered by you or any third party, arising from or in connection with your use of our Site and/or the Content and/or any inaccessibility of, interruption to or outage of our Site and/or any loss or corruption of data and/or the fact that the Content is incorrect, incomplete or out-of-date.
					</p>
					<p>
						<b style={{ color: 'black' }}> Indemnity​</b>
						: To the maximum extent permitted by law, you must indemnify us, and hold us harmless, against any Liability suffered or incurred by us arising from or in
						connection with your use of our Site or any breach of these Terms or any applicable laws by you. This indemnity is a continuing obligation, independent from the other obligations under these Terms, and continues after these Terms end.  It is not necessary for us to suffer or incur any Liability before enforcing a right of indemnity under these Terms.
					</p>
					<p>
						<b style={{ color: 'black' }}> Termination​</b>
						: These Terms are effective until terminated by us, which we may do at any time and without notice to you.  In the event of termination, all restrictions imposed on you by these Terms and limitations of liability set out in these Terms will survive.
					</p>
					<p>
						<b style={{ color: 'black' }}> Disputes​</b>
						: In the event of any dispute arising from, or in connection with, these Terms (​Dispute​), the party claiming there is a Dispute must give written notice to the other party setting out the details of the Dispute and proposing a resolution. Within 7 days after receiving the notice, the parties must, by their senior executives or senior managers (who have the authority to reach a resolution on behalf of the party), meet at least once to attempt to resolve the Dispute or agree on the method of resolving the Dispute by other means, in good faith.  All aspects of every such conference, except the fact of the occurrence of the conference, will be privileged. If the parties do not resolve the Dispute, or (if the Dispute is not resolved) agree on an alternate method to resolve the Dispute, within 21 days after receipt of the notice, the Dispute may be referred by either party (by notice in writing to the other party) to litigation.
					</p>
					<p>
						<b style={{ color: 'black' }}> Severance​</b>
						: If a provision of these Terms is held to be void, invalid, illegal or unenforceable, that provision must be read down as narrowly as necessary to allow it to be valid or enforceable. If it is not possible to read down a provision (in whole or in part), that provision (or that part of that provision) is severed from these Terms without affecting the validity or enforceability of the remainder of that provision or the other provisions in these Terms.
					</p>
					<p>
						<b style={{ color: 'black' }}> Jurisdiction​</b>
						: Your use of our Site and these Terms are governed by the laws of India. You irrevocably and unconditionally submit to the exclusive jurisdiction of the courts operating in New Delhi, India and any courts entitled to hear appeals from those courts and waive any right to object to proceedings being brought in those courts.
					</p>
					<p>Our Site may be accessed throughout India and overseas.  We make no representation that our Site complies with the laws (including intellectual property laws) of any country outside India.  If you access our Site from outside India, you do so at your own risk and are responsible for complying with the laws of the jurisdiction where you access our Site.</p>
					<p style={{ color: 'black' }}>
						<b>
							APICON SOLUTIONS PVT. LTD. +91-7780945282
							<br />
							Email: contact@supista.com
							<br />
							Last update: 1st September, 2020
						</b>
					</p>
				</div>

				{/* I understand button to close the T&C modal */}
				<button
					className='btn btn-sm btn-primary'
					onClick={() => { handleTnCModalClose(false) }}
				>
					I understand
				</button>
			</Box>
		</Modal>
	</>
}

export default TnCModal;